import { call, put, takeLatest } from "redux-saga/effects";
import {
  createFacultyStart,
  createFacultySuccess,
  createFacultyFailure,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpCreateFaculty } from "../../../services/faculty";
import { successNotifier } from "../../../utils/helpers";

export function* createFaculty({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpCreateFaculty, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(createFacultySuccess());
    successNotifier("faculty created successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(createFacultyFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onCreateFaculty() {
  yield takeLatest(createFacultyStart.type, createFaculty);
}
